export interface SkillCategory {
  title: string
  description: string
  skills: string[]
}

export const SKILL_CATEGORIES: SkillCategory[] = [
  {
    title: 'Cloud Platforms',
    description: 'Multi-cloud provisioning and cluster operations on Hetzner, AWS, Azure and GCP.',
    skills: ['Hetzner', 'AWS (EKS)', 'Azure (AKS)', 'GCP'],
  },
  {
    title: 'Infrastructure as Code & Configuration',
    description: 'Declarative, version-controlled infrastructure with GitOps tooling.',
    skills: ['Terraform', 'Ansible', 'Helm'],
  },
  {
    title: 'Containers & Orchestration',
    description: 'Container runtime and orchestration across Docker, Swarm and Kubernetes.',
    skills: ['Docker', 'Docker Swarm', 'Kubernetes'],
  },
  {
    title: 'CI/CD & GitOps',
    description: 'End-to-end delivery pipelines with GitLab CI, GitHub Actions and Argo CD.',
    skills: ['GitLab CI/CD', 'GitHub Actions', 'Argo CD'],
  },
  {
    title: 'Platform Engineering',
    description: 'Developer self-service with Backstage, Crossplane, Karpenter and vCluster.',
    skills: ['Backstage', 'Crossplane', 'Karpenter', 'vCluster'],
  },
  {
    title: 'Monitoring & Observability',
    description: 'Metrics, logs and traces across Prometheus, Grafana, ELK, Loki, Tempo and OTel.',
    skills: ['Prometheus', 'Grafana', 'ELK Stack', 'Loki', 'Tempo', 'OpenTelemetry'],
  },
  {
    title: 'Security & IAM',
    description: 'Secrets, identity and zero-trust access with Vault, OIDC, Zero Trust and Tailscale.',
    skills: ['HashiCorp Vault', 'OIDC', 'Zero Trust', 'Tailscale', 'CrowdSec'],
  },
  {
    title: 'Container & Runtime Security',
    description: 'Supply-chain and runtime protection with Trivy, Cosign, Falco, Kyverno and Istio mTLS.',
    skills: ['Trivy', 'Cosign', 'Falco', 'Kyverno', 'Istio mTLS'],
  },
  {
    title: 'Networking & Systems',
    description: 'Linux, hub-and-spoke networking, private clusters and Traefik.',
    skills: ['Linux', 'hub-and-spoke networking', 'private clusters', 'Traefik'],
  },
  {
    title: 'Programming & Version Control',
    description: 'Scripting, tooling and collaboration in Bash, Python, Go and Git.',
    skills: ['Bash', 'Python', 'Go', 'Git'],
  },
  {
    title: 'Languages',
    description: 'Professional working languages.',
    skills: ['English (C1)', 'French (C1)', 'Arabic (native)'],
  },
]